import { useState, useEffect } from "react";
import { Skeleton } from "@/components/ui/skeleton";

export default function Shimmer({
  initialRows = 1,
  maxRows = undefined,
  intervalDuration = 1000,
}: {
  initialRows?: number;
  maxRows?: number;
  intervalDuration?: number;
}) {
  const [rows, setRows] = useState(initialRows);
  const dummyArray = Array.from({ length: rows });
  useEffect(() => {
    let interval: string | number | NodeJS.Timeout | null | undefined = null;
    interval = setInterval(() => {
      setRows((count) => (maxRows ? (count < maxRows ? count + 1 : count) : count + 1));
    }, intervalDuration);
    return () => {
      if (interval) clearInterval(interval);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {dummyArray.map((_, idx) => {
        return (
          <div
            className="flex flex-col align-center w-full animate-fadeIn"
            key={`block-${idx}`}
          >
            <div
              className={`${(idx + 1) % 4 === 0 ? "mb-[20px]" : "mb-[10px]"} font-600 text-[12px] h-[18px]`}
            >
              <Skeleton
                className={`h-[18px] ${(idx + 1) % 4 === 0 ? "w-[80%]" : "w-full"} rounded-[2px]`}
              />
            </div>
          </div>
        );
      })}
    </>
  );
}
